import React from 'react';
import {
  Page,
  StyleSheet,
  Text,
  View,
} from '@react-pdf/renderer';

import getLogoDimensionsForView, { RectangularDimensions } from '../utils/getLogoDimensionsForView';
import radiusToText from '../utils/radiusToText';

import { OrganizationBrandData, ReportDataType } from '../../../_libs/app/types';
import PdfImageFromAzureWithUri from '../../../atoms/PdfImageFromAzureWithUri';

interface CoverPropTypes {
  primaryBrand: OrganizationBrandData;
  reportData?: ReportDataType;
  radius: number;
  zipCode: string;
  uuid?: string;
}

const Cover = ({
  primaryBrand,
  radius,
  zipCode,
}: CoverPropTypes): JSX.Element => {
  const logoView = {
    width: 300,
    height: 300,
  };
  const logoDimensions: RectangularDimensions = getLogoDimensionsForView({
    width: primaryBrand.logoWidth,
    height: primaryBrand.logoHeight
  }, logoView);

  const Styles = StyleSheet.create({
    announcement: {
      fontFamily: 'Courier',
      textTransform: 'uppercase',
      fontSize: '12pt',
    },
    announcementTheme: {
      fontFamily: 'Times-Roman',
      fontSize: '30pt',
      lineHeight: 1.17,
    },
    announcementView: {
      width: '100%',
      height: '19%',
      top: 0,
      left: 0,
      fontFamily: 'Times-Roman',
      color: 'black',
      zIndex: 3,
      padding: 36.5,
    },
    topView: {
      width: '100%',
      height: '47%',
      display: 'flex',
      alignContent: 'center',
      justifyContent: 'center',
      textAlign: 'left',
      padding: 36.5,
    },
    logoView: {
      height: logoView.width,
      width: logoView.height,
      display: 'flex',
      justifyContent: 'center',
    },
    logo: {
      width: logoDimensions?.width,
      height: logoDimensions?.height,
    },
    colorView: {
      height: '34%',
      width: '100%',
      backgroundColor: primaryBrand.colors.dark,
      color: 'white',
      padding: 36.5,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      fontSize: 14,
      lineHeight: 1.14,
    },
    colorViewEmphasis: {
      fontFamily: 'Times-Bold',
      fontSize: 16,
    },
  });

  const date = new Date().toLocaleDateString('en-us', { year:'numeric', month:'long', day:'numeric' });

  return (
    logoDimensions &&
      <Page
        size="LETTER"
      >
        <View style={Styles.announcementView}>
          <View style={Styles.announcement}>
            <Text>Generated for</Text>
          </View>
          <View style={Styles.announcementTheme}>
            <Text>{primaryBrand.name}</Text>
          </View>
        </View>
        <View style={Styles.topView} >
          <View style={Styles.logoView}>
            <PdfImageFromAzureWithUri
              fileUri={primaryBrand.logoUrl}
              style={Styles.logo}
            />
          </View>
        </View>
        <View
          style={Styles.colorView}
        >
          <Text style={{
            fontFamily: 'Courier',
            fontSize: 14,
          }}>radian™ Health Equity Toolkit</Text>
          <Text>
            This document was generated on <Text style={Styles.colorViewEmphasis}>{date}</Text> for <Text style={Styles.colorViewEmphasis}>{primaryBrand.name}</Text>. 
            It contains Health Equity insights, recommendations, and community-facing materials for neighborhoods located within <Text style={Styles.colorViewEmphasis}>{radiusToText(radius)}</Text> of <Text style={Styles.colorViewEmphasis}>{zipCode}</Text>.</Text>
        </View>
      </Page>
  );
};

export default Cover;
